module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAANCAYAAACQN/8FAAAA0klEQVQokX3QoW4CQRDG8f8QRHkEkjr03hMUgSumdU0aBA9QsaYkOJDIPUkCloSqJlU1xSDQaxAg8TiC2sEcYbkuTLLJl8kvmZ0RE9wrMAYWwNyL/SZRoqpkmjvAFr2ZF9tJQoBM8y3QKPpLL7YZw0qUv6L8lGk+vAVXpWmDTPPHFFwnduj9g17sBjiU4Ns5iAmuDdSBIzABaiXcB3ZV4AGYJsaeawSXO7aAvzu4WSn+twBebqBnL3YZL/MDdEvo3Yv9BUBVr54J7tMEtzfBfcT9E4BGUnAU7lAIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/newmould/down.png
// module id = HxlU
// module chunks = 3